// extracted by mini-css-extract-plugin
export var container = "styles-module--container--Ig-TQ";
export var desktop = "1340px";
export var dockedBottom = "styles-module--dockedBottom--KoRln";
export var dockedTop = "styles-module--dockedTop--UqEiL";
export var giant = "2200px";
export var grid = "styles-module--grid--9aRYH";
export var gridItem = "styles-module--gridItem--6QFYT";
export var gridItemBackground = "styles-module--gridItemBackground--rrTdr";
export var gridItemContent = "styles-module--gridItemContent--RP1EH";
export var gridItemContentType = "styles-module--gridItemContentType--mjUqX";
export var gridItemL = "styles-module--gridItemL--eVjxE";
export var gridItemM = "styles-module--gridItemM--5i8eo";
export var gridItemS = "styles-module--gridItemS--2Pox7";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var padded = "styles-module--padded--r3fOC";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";